const createFormattedAddress = (address: any, usFormat?: boolean) =>
  `${usFormat ? `${address.streetNumber} ${address.street}` : `${address.street} ${address.streetNumber}`}, ${
    address.city
  }, ${usFormat ? `${address.state} ${address.zip}` : `${address.zip} ${address.state}`}, ${address.country}`;

export default createFormattedAddress;
